/**
 * @generated SignedSource<<4e5727866dd0a5d81fbbc1426fdf7881>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsSpecialPriceDates$data = {
  readonly endAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  } | null;
  readonly startAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  } | null;
  readonly " $fragmentType": "ProductDetailsSpecialPriceDates";
};
export type ProductDetailsSpecialPriceDates$key = {
  readonly " $data"?: ProductDetailsSpecialPriceDates$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsSpecialPriceDates">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "SHORT_DATE"
      }
    ],
    "kind": "FragmentSpread",
    "name": "StoreFormattedDate"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsSpecialPriceDates",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "startAtDate",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "endAtDate",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ProductStoreSpecialPrice",
  "abstractKey": null
};
})();

(node as any).hash = "877b90070d2a8362ce8d38f310d65f3a";

export default node;
